import React from 'react';

import Routes from './routes';
import { createRoot } from 'react-dom/client'
createRoot(document.getElementById('root')).render(<Routes />)
